import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import SharedCalenderPage from '../../../shared/components/pages/calenderPage/CalenderPage';
import CalenderPageMobile from '../../../shared/components/pages/calenderPage/calenderPageMobile/CalenderPageMobile';
import Page from '../../../shared/components/ui/page/Page';
import pathRouts from '../../../shared/enums/pathRoute';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import { deviceTypes } from '../../../shared/enums/deviceTypes';

const CalenderPage = () => {

    const navigate = useNavigate();
    const { texts } = useSelector(state => state.translate);
    const deviceType = useSelector(state => state.responsive.deviceType);

    return (
        <Page
            title={texts.calendar}
            icon={iconsList.calendar}
            onBack={() => navigate(`/${pathRouts.HOME}`)}
        >
            {deviceType === deviceTypes.mobile
                ? <CalenderPageMobile />
                : <SharedCalenderPage />}
        </Page>
    );
};

export default CalenderPage;
